// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav_nav__AXA_3","nav__link":"nav_nav__link__ttc4m","icon":"nav_icon__wWsZB"};